<template>
	<div class="v_box">
		<div @click="myPersonal" class="v_boxlist">
			<img src="../../public/img/dingdanguanli.png" alt="">
		</div>
		<div @click="myshopCar" class="v_boxlist">
			<img src="@/assets/img/shopico.png" alt="">
			<div class="v_boxlistnum" v-if="username != ''">
				{{this.$store.state.shopcarNum}}

			</div>
		</div>
		<!--<a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=732536302&site=qq&menu=yes" class="v_boxlist">-->
		<a class="v_boxlist zhichibtns" target="_blank" href="https://51wenju.sobot.com/chat/pc/v2/index.html?sysnum=47a475ba652b483680cd0a13382f777d&channelid=2">
			<img src="@/assets/img/women.png" alt="">
		</a>

		<div class="v_boxlist" @click="toTop">
			<img src="@/assets/img/topico.png" alt="">
		</div>
	</div>
</template>
<script>
//		let user_data;
//		if (JSON.parse(localStorage.getItem('user_data'))) {
//			user_data = JSON.parse(localStorage.getItem('user_data')).value;
//		} else{
//			user_data = {user_name:"",realname:'',tel:''};
//		}
//	
//		(function(w, d, e, x) {  
//			w[e] = function() {    
//				w.cbk = w.cbk || [];    
//				w.cbk.push(arguments);  
//			}  
//			x = d.createElement('script');  
//			x.async = true;  
//			x.id = 'zhichiScript';
//			x.className = 'zhichibtns';   
//			x.src = 'https://51wenju.sobot.com/chat/frame/v2/entrance.js?sysnum=47a475ba652b483680cd0a13382f777d';  
//			d.body.appendChild(x);
//		})(window, document, 'zc');
//		zc('config', {   
//			uname:user_datat.user_name, //客户名称
//			realname:user_datat.name, //客户真实姓名
//			tel:user_datat.mobile_phone, //客户电话,
//			channelid: 2,
//			custom: true,
//		})
	import qs from 'qs'
	export default {
		data() {
			return {
				username: '',
				personalData: {}, //购物车数量所需数据
				personalData1: 0, //购物车数量
			}
		},
		created() {
			let that = this;
			//			that.ScrollUp();

			if(that.$storage.get('user_data') != null) {
				that.username = that.$storage.get('user_data').alias;
				that.personalData['user_id'] = that.$storage.get('user_data').user_id;
				that.personalFn();
			} else {
				that.username = '';
				that.personalData = {};
			}
		},
		methods: {
			toTop() {
				let top = document.documentElement.scrollTop || document.body.scrollTop;
				// 实现滚动效果
				const timeTop = setInterval(() => {
					document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
					if(top <= 0) {
						clearInterval(timeTop);
					}
				}, 10);
			},
			myPersonal() {
				let that = this;
				if(that.$storage.get('user_data') == null) {
					that.$message({
						message: '请先登录或注册！',
						type: 'warning'
					});
				} else {
					that.$router.push({
						path: "/personalOrder",
						query: {}
					});
				}

			},
			myshopCar() {
				let that = this;
				if(that.$storage.get('user_data') == null) {
					that.$message({
						message: '请先登录或注册！',
						type: 'warning'
					});
				} else {
					that.$router.push({
						path: "/shopcarIndex",
						query: {}
					});
				}

			},
			//获取个人中心基础数据
			personalFn() {
				let that = this;

				axios({
						method: 'post',
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
						},
						url: that.$publicUrl.http1 + that.$publicUrl.personalmessage,
						data: qs.stringify(that.personalData),

					})
					.then(function(response) {
						//						console.log(response);
						let data = response.data;
						if(data.stateCode == 10000) {
							that.personalData1 = data.countGoods

						} else {
							that.personalData1 = 0
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
		},

	}
</script>
<style scoped>
	.v_box {
		background-color: #fbac30;
		position: fixed;
		right: 0;
		top: 50%;
		transform: translateY(-50%);
		z-index: 100;
	}
	
	.v_boxlist {
		width: 80px;
		display: block;
		padding: 10px;
		box-sizing: border-box;
		cursor: pointer;
		position: relative;
		border-bottom: 1px dashed #ffffff;
	}
	
	.v_boxlist:last-child {
		border-bottom: 0px dashed #ffffff;
	}
	
	.v_boxlist img {
		display: block;
		height: 60px;
		width: 60px;
		object-fit: scale-down;
	}
	
	.v_boxlistnum {
		max-width: 20px;
		overflow: hidden;
		padding: 0 5px;
		color: #FFFFFF;
		font-size: 10px;
		position: absolute;
		top: 10px;
		left: 50%;
		background-color: #dc1e33;
		border-radius: 5px;
		z-index: 101;
	}
	.v_boxlist_hover{
		position: absolute;
		right: 80px;
		display: none;
		flex-wrap: nowrap;
		background-color: #fbac30;
		top: 0;
	}
	.v_boxlist:hover .v_boxlist_hover{
		display: flex;
	}
	.v_boxlist_hover_item {
		box-sizing: border-box;
		display: inline-block;
		width: 90px;
		height: 80px;
		border-left: 1px dashed #cccccc;
		background-image: url(../../public/img/fcan.png);
		background-position: center 16px;
		background-repeat: no-repeat;
		background-size: 30%;
		
	}
	.v_boxlist_img{
		display: inline-block;
		margin-top: 50px;
    	width: 100%;
    	height: 30px;
    	line-height: 30px;
    	text-align: center;
   		font-size: 12px;
    	color: #ffffff;
	}
</style>